import { Button, Col, Row } from 'reactstrap';
import Todo from './components/todo';

const ActivityFormComponent = ({ handleOnSubmit, defaultValues, editMode }) => {
  return (
    <Todo
      form={defaultValues.form}
      handleOnSubmit={handleOnSubmit}
      editMode={editMode}
    />
  );
};

export default ActivityFormComponent;
